let resumeData = [
  {
    company: "General Assembly",
    title: " Software Engineering Fellow",
    start: "4.2020",
    end: "7.2020",
    bullets: ["Building full-stack, full CRUD desktop, tablet and mobile applications utilizing different backend technologies (express, rails, python) with React frontends", "See all projects by clicking 'Projects' above"]

  },

  {
    company: "Lesson4u Japan",
    title: "Hiring and Technology Manager",
    start: "10.2011",
    end: "4.2020",
    bullets: ["Consulted, created Salesforce build tailored to school's reporting, student management, client contact needs, associated staff training and documentation (Eng/Jap)", "Created automated workflow for student records", "Recruiting and hiring teachers from abroad and training on school curricula"]

  },

  {
    company: "Sunlight Studios",
    title: "Associate Manager",
    start: "11.2018",
    end: "4.2020",
    bullets: ["Consulted, built, implemented automated workflows for invoice and revenue reporting, CRM and client management, tailored to studio's needs", "Built and maintained relationships with Broadway insiders, consulted and tailored studio services to their needs with high confidentiality and excellent customer service", "Maintained and troubleshooted all hardware and software systems (Wifi, intranet/SMB server, audio interface, security and HVAC systems)"]

  },

  {
    company: "CIEE Academic Internship Council",
    title: "Senior Global Internship Advisor",
    start: "9.2016",
    end: "7.2018",
    bullets: ["Created, implemented, managed automated workflow to manage 3,000+ student applications and internship placement process over 18 international locations", "Advised on best SaaS systems and application technical features to implement based on staff needs", "Built and maintained relationships with universities and students, consulted on programs"
    ]

  }

]

export default resumeData


